import type { AgendaModuleDto } from "@/repositories/agendaModuleRepo";
import React, { createContext, useContext } from "react";

export const AgendaModuleDefaultsContext =
  createContext<Partial<AgendaModuleDto> | null>(null);

export const AgendaModuleDefaults = ({
  defaults,
  children,
}: {
  defaults: Partial<AgendaModuleDto>;
  children?: React.ReactNode;
}) => {
  const prevDefaults = useContext(AgendaModuleDefaultsContext);
  const nextDefaults = { ...prevDefaults, ...defaults };

  return (
    <AgendaModuleDefaultsContext.Provider value={nextDefaults}>
      {children}
    </AgendaModuleDefaultsContext.Provider>
  );
};
